import React, { Component } from 'react';
import Dialog from '@mui/material/Dialog';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import AppBar from '@mui/material/AppBar';
import ProjectSelect from '../Projects/ProjectSelect'
import UserSelect from '../Users/UserSelect'
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';
import { observer } from 'mobx-react';
import InputLabel from '@mui/material/InputLabel';
import Input from '@mui/material/Input';
import File from '../File/File';
import LinkBoard from '../Link/LinkBoard';
import authStore from '../../Auth/AuthStore';
import mainStore from '../../../MainStore';
import WorkStore from '../Kanban/WorkStore';
import ClientCommentBlock from './ClientCommentBlock';
import FilePanel from '../File/FilePanel';
import Menu from '@mui/material/Menu';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import IconButton from '@mui/material/IconButton';
import SchedulleStore from '../Scheduller/SchedulleStore';
import InputAdornment from '@mui/material/InputAdornment';
import CopyIcon from '@mui/icons-material/FileCopy';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import { Editor } from 'ckeditor5-custom-build/build/ckeditor';

//import TodoList from '@ckeditor/ckeditor5-list/src/todolist';


const ClientWorkDialog = observer(class ClientWorkDialog extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isMenuOpen: false,
            anchorEl: null,
            fullscreen: false,
            comment: ''
        };

        this.handleTabChange = this.handleTabChange.bind(this);
        this.handleRowCheckedChange = this.handleRowCheckedChange.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleDescriptionChange = this.handleDescriptionChange.bind(this);
        this.handleMenuClick = this.handleMenuClick.bind(this);
        this.handleMenuClose = this.handleMenuClose.bind(this);
        this.handleCommentChange = this.handleCommentChange.bind(this);
        this.cloneWork = this.cloneWork.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.handleCostUpdate = this.handleCostUpdate.bind(this);
        this.handleCostSave = this.handleCostSave.bind(this);
    }

    scrollPosition = 0

    componentDidUpdate() {
            this.scrollPosition = window.scrollY;
    }

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    handleScroll(event) {
        if (this.scrollPosition !== 0) {
            var pos = this.scrollPosition;
            this.scrollPosition = 0;
            window.scrollTo(0, pos);
        }
    }

    handleClose() {
        if (!WorkStore.getWork.id) {
            var res = window.confirm("Ты уверен что хочешь закрыть не сохраненную карточку?? Подумай!");
            if (res) {
                WorkStore.closeWorkDialog();
            }
            else {
                return;
            }
        }
        WorkStore.closeWorkDialog();
    }

    handleCostUpdate(costs) {
        this.setState({costs: costs});
    }

    handleCostSave(callback) {
        mainStore.setMaskVisible();
        var token = localStorage.getItem("token");
        fetch('api/Work/SaveCosts', {
            method: 'POST',
            body: JSON.stringify(this.state.costs),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
                authStore.openLogin();
                mainStore.setMaskUnvisible();
                //scope.startSearch();
            }
            else {
                res.json().then((result) => {
                    mainStore.setMaskUnvisible();
                    callback();

                }).catch((err) => console.log(err));
            }
        });
    }

    handleTabChange(event, newValue) {
        WorkStore.setSelectedTab(newValue);
    }

    handleCommentChange(evt) {
        this.setState(evt);
    }

    handleRowCheckedChange = name => evt => {
        var work = WorkStore.getWork;
        work[name] = evt.target.checked;
        WorkStore.setWork(work);
    }

    handleDescriptionChange(text) {
        var work = WorkStore.getWork;
        work.description = text;
        WorkStore.setWork(work);
    }

    handleRowDataChange = name => evt => {
        var work = WorkStore.getWork;
        work[name] = evt.target.value;
        WorkStore.setWork(work);
    }

    cloneWork() {
        mainStore.setMaskVisible();
        var token = localStorage.getItem("token");
        fetch('api/Work/Clone', {
            method: 'POST',
            body: JSON.stringify(WorkStore.getWork.id),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
                authStore.openLogin();
                mainStore.setMaskUnvisible();
                //scope.startSearch();
            }
            else {
                res.json().then((result) => {
                    mainStore.setMaskUnvisible();
                    WorkStore.openWorkDialog(result);
                }).catch((err) => console.log(err));
            }
        });
    }

    handleSave() {
        if (this.state.comment) {
            alert("У тебя остался неотправленный комментарий. УДАЛИ!!!!");
            return;
        }
        var scope = this;
        mainStore.setMaskVisible();
        var token = localStorage.getItem("token");
        fetch('api/Work/ClientSave', {
            method: 'POST',
            body: JSON.stringify(WorkStore.getWork),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
                authStore.openLogin();
                mainStore.setMaskUnvisible();
            }
            else {
                res.json().then((result) => {
                    if (scope.props.onWorkUpdate) {
                        scope.props.onWorkUpdate(result);
                    }

                    mainStore.setMaskUnvisible();
                    WorkStore.closeWorkDialog();

                }).catch((err) => console.log(err));
            }
        });
    }

    handleProjectChange(project) {
        var work = WorkStore.getWork;
        work.projectId = project.id;
        work.projectName = project.name;
        WorkStore.setWork(work);
    }

    handleAssigneeChange(user) {
        var work = WorkStore.getWork;
        work.assigneeId = !!user ? user.id : '';
        work.assignee = !!user ? user.name: '';
        WorkStore.setWork(work);
    }

    handleTesterChange(user) {
        var work = WorkStore.getWork;
        work.testerId = user.id;
        work.tester = user.name;
        WorkStore.setWork(work);
    }

    handleMenuClick(evt) {
        this.setState({ anchorEl: evt.currentTarget, isMenuOpen: true});
    }

    handleMenuClose() {
        this.setState({ anchorEl: null, isMenuOpen: false });
    }

    handleDeleteWork() {
        const conf = window.confirm("Ты уверен что точно хочешь прямо удалить эту задачу? Потом вернуть ее будет возможно!");
        if (conf) {
            var scope = this;
            mainStore.setMaskVisible();
            var token = localStorage.getItem("token");
            fetch('api/Work/Delete', {
                method: 'POST',
                body: JSON.stringify({ id: WorkStore.getWork.id }),
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + token
                }
            }).then(function (res) {
                if (res.status === 401) {
                    authStore.openLogin();
                    mainStore.setMaskUnvisible();
                    //scope.startSearch();
                }
                else {
                    res.json().then((result) => {
                        mainStore.setMaskUnvisible();
                        WorkStore.closeWorkDialog();
                    }).catch((err) => console.log(err));
                }
            });
        }
    }

    handleEditTime() {
        SchedulleStore.openSchedulleEditDialog({ workId: WorkStore.getWork.id, date: new Date(), workNumber: WorkStore.getWork.number, workCaption: WorkStore.getWork.caption });
    }

    render() {
        return (
            <Dialog
                disableEnforceFocus={true}
                onClose={this.handleClose}
                aria-labelledby="customized-dialog-title"
                open={WorkStore.isWorkDialogOpen}
                maxWidth="lg"
                fullWidth
                fullScreen={this.state.fullscreen}
                className={"work-kanban " + (this.state.fullscreen ? "fullscreen" : "")}
                TransitionProps={{
                    onExit: () => console.log(window.scrollY)
                }}>
                <DialogTitle id="customized-dialog-title">
                    <div className="work-dialog-number"><CopyToClipboard onCopy={() => { mainStore.openSnackbar('Скопировано в буфер обмена'); }} text={document.location.origin + '/board?work=' + encodeURIComponent(WorkStore.getWork.number)}><span>{WorkStore.getWork.number}</span></CopyToClipboard></div>
                    <div className="work-dialog-caption">
                        <FormControl fullWidth>
                            <InputLabel htmlFor="adornment-caption">Заголовок</InputLabel>
                            <Input
                                id="adornment-caption"
                                value={WorkStore.getWork.caption}
                                onChange={this.handleRowDataChange('caption')}
                                endAdornment={<InputAdornment position="end"><IconButton aria-label="toggle password visibility" onClick={() => {}} size="large">
                                    <CopyToClipboard onCopy={() => { mainStore.openSnackbar('Скопировано в буфер обмена'); }} text={WorkStore.getWork.number + " " + WorkStore.getWork.caption}>
                                        <CopyIcon />
                                    </CopyToClipboard>
                                </IconButton>
                                </InputAdornment>}
                            />
                        </FormControl>
                    </div>
                    <div className="action-button-block">
                        <IconButton
                            aria-label="more"
                            aria-controls="long-menu"
                            aria-haspopup="true"
                            onClick={this.handleMenuClick}
                            size="large">
                            <MoreVertIcon />
                        </IconButton>
                        <Menu
                            id="long-menu"
                            anchorEl={this.state.anchorEl}
                            keepMounted
                            open={this.state.isMenuOpen}
                            onClose={this.handleMenuClose}
                            PaperProps={{
                                style: {
                                    maxHeight: 200,
                                    width: 200,
                                },
                            }}
                        >
                            <MenuItem key={2} onClick={this.cloneWork}>
                                Клонировать
                            </MenuItem>
                        </Menu>
                        {!this.state.fullscreen && <IconButton onClick={() => { this.setState({ 'fullscreen': true }); }} size="large">
                            <FullscreenIcon />
                        </IconButton>
                        }
                        {this.state.fullscreen && <IconButton onClick={() => { this.setState({ 'fullscreen': false }); }} size="large">
                            <FullscreenExitIcon />
                        </IconButton>

                        }

                        <Button onClick={this.handleSave} color="primary" className="work-dialog-save-button">
                            Сохранить
                         </Button>
                    </div>
                    {WorkStore.getWork.crmLink && <a href={WorkStore.getWork.crmLink} target="_blank" rel="noopener noreferrer">CRM</a>}
                </DialogTitle>
                <DialogContent dividers>
                    <div className="work-dialog-bar clearfix">
                        <AppBar position="static" color="default" className="short-appbar">
                            <Tabs
                                value={WorkStore.getSelectedTab}
                                onChange={this.handleTabChange}
                                indicatorColor="primary"
                                textColor="primary"
                                variant="scrollable"
                                scrollButtons="auto"
                            >
                                <Tab label="Главная" />
                                <Tab label="Вложения" />
                                <Tab label="Комментарии" />
                            </Tabs>
                        </AppBar>
                    </div>
                    {WorkStore.getSelectedTab === 0 && <div className="card-inner-block card-inner-block-work">
                        <div className="left-work-block card-block client-card-block">
                            <CKEditor
                                editor={Editor}
                                data={WorkStore.getWork.description}
                                onChange={(event, editor) => {
                                    const data = editor.getData();
                                    this.handleDescriptionChange(data);
                                }}
                                />
                            <FilePanel key={WorkStore.getWork.id} workId={WorkStore.getWork.id} sessionId={WorkStore.getWork.sessionId} />
                        </div>
                        <div className="right-work-block">
                            <div className="right-fields-work-block"> 
                                <Typography component={'span'}>
                                    <div className="clearfix">
                                        <div className="half-block">
                                            <ProjectSelect disabled={true} name={WorkStore.getWork.projectName} handleSelect={this.handleProjectChange} />
                                        </div>
                                        <div className="half-block">
                                            <FormControl>
                                                <InputLabel htmlFor="priority-select">Приоритет</InputLabel>
                                                <Select
                                                    value={WorkStore.getWork.priorityId}
                                                    onChange={this.handleRowDataChange('priorityId')}
                                                    input={<Input name="priority-select" id="priority-select" />}
                                                >
                                                    <MenuItem value="e025b304-80eb-4870-94e9-d0512984595b">Высочайший</MenuItem>
                                                    <MenuItem value="a2c913e8-8505-4d62-830c-f8c6b76e65e5">Высокий</MenuItem>
                                                    <MenuItem value="03d3011c-7afe-4c9e-aeee-9ec56323a1e1">Средний</MenuItem>
                                                    <MenuItem value="d70acf59-b060-40b3-9aa5-7d6e7adbeb94">Низкий</MenuItem>
                                                    <MenuItem value="dba44be7-64be-4e03-99d1-d20b1c9bd13c">Нижайший</MenuItem>
                                                    <MenuItem value="a9ae204e-085a-4898-ba85-28baa775b98d">Не делать</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </div>
                                    </div>
                                </Typography>
                                <Typography component={'span'}>
                                        <TextField required
                                            id="standard-fact-required"
                                            label="Согл"
                                            fullWidth
                                            type="number"
                                            margin="none"
                                            disabled
                                            value={WorkStore.getWork.approvedHour}
                                            onChange={this.handleRowDataChange('approvedHour')}
                                        />
                                </Typography>
                                <Typography component={'span'}>
                                   
                                </Typography>
                                <Typography component={'span'}>
                                    <div className="tester-block">
                                        <UserSelect disabled={true} name={WorkStore.getWork.assignee} label="Ответственный" handleSelect={this.handleAssigneeChange} />
                                    </div>
                                </Typography>
                                <Typography component={'span'}>
                                    <div className="tester-block">
                                        <UserSelect disabled={true} name={WorkStore.getWork.tester} label="Тестирует" handleSelect={this.handleTesterChange} />
                                    </div>
                                </Typography>
                                <Typography component={'span'}>
                                    <div className="clearfix">
                                        <div className="half-block">
                                            <TextField required
                                                id="standard-required"
                                                label="Состояние"
                                                fullWidth
                                                disabled
                                                margin="none"
                                                value={WorkStore.getWork.status}
                                                onChange={this.handleRowDataChange('status')}
                                            />
                                        </div>
                                        <div className="half-block">
                                            <FormControlLabel
                                                control={
                                                    <Checkbox disabled checked={WorkStore.getWork.isFlagged} onChange={this.handleRowCheckedChange('isFlagged')} value="true" />
                                                }
                                                label="Флаг"
                                        />
                                        </div>
                                    </div>
                                </Typography>
                                <Typography component={'span'}>
                                    <div className="clearfix">
                                        <FormControlLabel
                                            control={
                                                <Checkbox disabled checked={WorkStore.getWork.isPortal} onChange={this.handleRowCheckedChange('isPortal')} value="true" />
                                            }
                                            label="Портал"
                                        />
                                    </div>
                                </Typography>
                            </div>
                            {false && <div className="link-board-wrapper"><LinkBoard workId={WorkStore.getWork.id} /></div>}
                        </div>
                    </div>}
                    {WorkStore.getSelectedTab === 1 && <div className="card-inner-block card-inner-block-work"><File workId={WorkStore.getWork.id} /></div>}
                    {WorkStore.getSelectedTab === 2 && <div className="card-inner-block card-inner-block-work"><Typography>Комментарии</Typography>
                        <ClientCommentBlock key={WorkStore.getWork.id} workId={WorkStore.getWork.id} sessionId={WorkStore.getWork.sessionId} handleParentChange={this.handleCommentChange} /></div>}
                </DialogContent>
            </Dialog>
        );
    }
});

export default ClientWorkDialog;